import { differenceInYears } from 'date-fns';

export const getAge = (dateString: Date | string | number): number => {
  return differenceInYears(
    new Date(),
    typeof dateString === 'string' ? new Date(dateString) : dateString,
  );
};
